import React, { useEffect, useRef, useState } from "react";
import { Box, Stack, Typography } from "@mui/material";
import MobileCustomCard from "./MobileCustomCard";
import Img1 from "./cardImg/education.jpeg";
import Img2 from "./cardImg/health1.jpeg";
import Img3 from "./cardImg/finace1.jpeg";
import Img4 from "./cardImg/ecom1.jpeg";
import Img5 from "./cardImg/retail1.jpeg";
import Img6 from "./cardImg/travel1.jpeg";
import Img7 from "./cardImg/hospital1.jpeg";
import Img8 from "./cardImg/logistics.jpeg";
import Img9 from "./cardImg/realEstate.jpeg";
import Img10 from "./cardImg/insurace.jpeg";
import Img11 from "./cardImg/enterm.jpeg";
import Img12 from "./cardImg/govt.jpeg";
import NewCustomCard from "../../Header/NewCustomCard";


const MobileHeroScroll = () => {
  // Dummy Data for 12 Cards
  const cardData = [
    {
      card_id: 1,
      title: "Education & Edtech 🎓",
      description: "Engage students and simplify admissions. ",
      img: Img1,
      badge: "New",
    },
    {
      card_id: 2,
      title: "Healthcare 🏥",
      description:
        "Streamline patient communication and appointment management through WhatsApp. A healthier way to connect.",
      img: Img2,
      badge: "New",
    },
    {
      card_id: 3,
      title: "Finance 💰",
      description:
        "Automate reminders, paymentsand customer queries for seamless financial services.",
      img: Img3,
      badge: "New",
    },
    {
      card_id: 4,
      title: "E-commerce 🛍️",
      description:
        "Enhance your customer experience with order tracking, notificationsand support on WhatsApp.",
      img: Img4,
      badge: "New",
    },
    {
      card_id: 5,
      title: "Retail 🛒",
      description:
        "Boost sales by automating personalized offers and customer engagement via WhatsApp.",
      img: Img5,
      badge: "Premium",
    },
    {
      card_id: 6,
      title: "Travel & Tourism ✈️",
      description:
        "Simplify bookings, itinerariesand real-time updates through WhatsApp for travelers.",
      img: Img6,
      badge: "Premium",
    },
    {
      card_id: 7,
      title: "Hospitality 🏨",
      description:
        "Offer a seamless guest experience with booking confirmations and customer support on WhatsApp.",
      img: Img7,
      badge: "Premium",
    },
    {
      card_id: 8,
      title: "Logistics 🚚",
      description:
        "Automate delivery notifications, order trackingand customer support for smooth logistics operations.",
      img: Img8,
      badge: "Premium",
    },
    {
      card_id: 9,
      title: "Real Estate 🏠",
      description:
        "Engage leads, schedule site visitsand share property details easily via WhatsApp.",
      img: Img9,
      badge: "Upcoming",
    },
    {
      card_id: 10,
      title: "Insurance 🛡️",
      description:
        "Assist customers with policy information, claimsand renewals through WhatsApp.",
      img: Img10,
      badge: "Upcoming",
    },
    {
      card_id: 11,
      title: "Media & Entertainment 🎥",
      description:
        "Promote events, manage ticketsand engage audiences through WhatsApp.",
      img: Img11,
      badge: "Upcoming",
    },
    {
      card_id: 12,
      title: "Government Services 🏛️",
      description:
        "Enable citizens to access government services and updates conveniently on WhatsApp.",
      img: Img12,
      badge: "Upcoming",
    },
  ];

  return (
    <Stack
      sx={{
        display: "flex",
        flexDirection: "row",
        overflowX: "auto",
        "&::-webkit-scrollbar": {
          display: "none", // Hides scrollbar for WebKit browsers like Chrome, Safari
        },
        "-ms-overflow-style": "none", // Hides scrollbar for IE and Edge
        "scrollbar-width": "none", // Hides scrollbar for Firefox
        // border: "1px solid red",
      }}
    >
      <Stack
        sx={{
          width: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          marginTop: "20px",
        }}
      >
        <Stack
          sx={{
            // border: "1px solid red",
            width: "93%",
            display: "flex",
            flexDirection: "row",
          }}
        >
          <Stack
            sx={{
              //  border: "1px solid red",
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Stack
              sx={{
                width: { xl: "6px", lg: "6px", xs: "4px" },
                // height: { xl: "100%", lg: "100%", xs: "100%" },
                height: {
                  xs: "20px",
                  sm: "44px",
                  md: "28px",
                  lg: "40px",
                  xl: "40px",
                },
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                border: "1px solid rgb(5 78 146)",
                backgroundColor: "rgb(5 78 146)",
                marginRight: {
                  xs: "8px",
                  sm: "8px",
                  md: "12px",
                  lg: "12px",
                  xl: "12px",
                },
                borderTopRightRadius: "8px", // Adjust the value as needed
                borderBottomRightRadius: "8px", // Adjust the value as needed
              }}
            >
              <h4 style={{ color: "rgb(5 78 146)" }}>{""}</h4>
            </Stack>
          </Stack>
          <Stack
            sx={{
              fontSize: {
                xs: "20px",
              },
              lineHeight: {
                xs: "32px",
                sm: "32px",
                md: "48px",
                lg: "56px",
                xl: "56px",
              },
              fontWeight: { xs: 600, sm: 600, md: 600, lg: 600, xl: 600 },
              color: "rgb(5 78 146)",
              fontFamily: "'Roboto', sans-serif",
              textAlign: {
                xl: "left",
                lg: "left",
                md: "left",
                sm: "left",
                xs: "left",
              },
            }}
          >
            Industry WhatsApp use cases
          </Stack>
        </Stack>

        <Stack
          sx={{
            width: "93%",
            fontFamily: "'Roboto', sans-serif",
            fontSize: {
              xs: "16px",
              sm: "16px",
              md: "16px",
              lg: "24px",
              xl: "24px",
            },
            lineHeight: {
              xs: "22px",
              sm: "28px",
              md: "32px",
              lg: "32px",
              xl: "32px",
            },
            display: {
              xl: "none",
              lg: "none",
              md: "none",
              sm: "none",
              xs: "flex",
            },
            fontWeight: { xs: 400, sm: 400, md: 400, lg: 400, xl: 400 },
            color: "#333",
            textAlign: "left",
            border: "1px solid rgb(218 233 248)",
            padding: 1,
            borderRadius: "8px",
            backgroundColor: "rgb(218 233 248)",
            marginBottom: { xl: "0px", lg: "40px", md: "20px" },
            marginTop: "8px",
          }}
        >
          {/* #1976d2 */}
          <span>
            WhatsApp makes it easy to connect with people. It's fast, secure and
            already trusted by billions for everyday conversations.
          </span>
        </Stack>

        {/* <Stack
          ref={scrollRef}
          direction="row"
          sx={{
            border: "1px solid red",
            overflowX: "auto",
            scrollSnapType: "x mandatory",
            px: "calc(50vw - 160px)", // Centers 320px wide card
            gap: 2,
            marginBottom: "20px",
            width: "100%",
            "&::-webkit-scrollbar": {
              display: "none",
            },
          }}
        >
          {cardData.map((card, index) => (
            <Box
              key={card.card_id}
              sx={{
                flex: "0 0 auto",
                // padding: "4px",
                border: "1px solid blue",
                scrollSnapAlign: "center",
                width: "80vw",
                maxWidth: "320px",
                transition: "transform 0.3s ease",
                // transform: centerIndex === index ? "scale(1.04)" : "scale(1)",
                zIndex: centerIndex === index ? 2 : 1,
              }}
            >
              <NewCustomCard
                card_id={card.card_id}
                title={card.title}
                description={card.description}
                img={card.img}
                bgColor={card.bgColor}
              />
            </Box>
          ))}
        </Stack> */}

      
      </Stack>
    </Stack>
  );
};

export default MobileHeroScroll;
